const TIFF_NAME_RE = /\.tiff?(\?|#|$)/i;

export function isTiffContent(
  fileName: string,
  fileContentType: string,
): boolean {
  const ct = (fileContentType || "").toLowerCase().split(";")[0].trim();
  if (ct === "image/tiff" || ct === "image/x-tiff") {
    return true;
  }
  return TIFF_NAME_RE.test((fileName || "").toLowerCase());
}

/** True when the attachment should use the TIFF viewer instead of a plain `img` tag. */
export function isTiffPreviewPath(
  fileContent: string,
  fileName: string,
  fileContentType: string,
): boolean {
  if (isTiffContent(fileName || "", fileContentType || "")) {
    return true;
  }
  const s = (fileContent || "").trim();
  if (!s) {
    return false;
  }
  if (/^data:image\/tiff/i.test(s)) {
    return true;
  }
  if (/^https?:\/\//i.test(s) && TIFF_NAME_RE.test(s)) {
    return true;
  }
  return false;
}

export async function fetchTiffArrayBuffer(source: string): Promise<ArrayBuffer> {
  const s = source.trim();
  if (!s) {
    throw new Error("No TIFF data to load.");
  }

  if (s.startsWith("blob:") || s.startsWith("data:")) {
    const res = await fetch(s);
    if (!res.ok) {
      throw new Error(`Failed to load TIFF (${res.status})`);
    }
    return res.arrayBuffer();
  }

  if (s.startsWith("http://") || s.startsWith("https://")) {
    const res = await fetch(s, {
      credentials: "include" as RequestCredentials,
      mode: "cors" as RequestMode,
    });
    if (!res.ok) {
      throw new Error(`Failed to load TIFF (${res.status})`);
    }
    return res.arrayBuffer();
  }

  const b64 = s.replace(/\s/g, "");
  const binary = atob(b64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}
